import { useContext } from 'react'

import { Box, BoxProps, Stack } from '@mantine/core'

import useStyles from './index.styles'
import { FeatureCardContext } from '../../context'

type Props = BoxProps
export const VerticalLayout = ({ styles, className, classNames }: Props) => {
  const { sectionName, heading, content } = useContext(FeatureCardContext)
  const { classes, cx } = useStyles(undefined, {
    name: 'FeatureCard__VerticalLayout',
    styles,
    classNames,
  })
  return (
    <Stack className={cx(className, classes.root)}>
      <Stack className={classes.header}>
        {sectionName}
        {heading}
      </Stack>
      <Box className={classes.body}>{content}</Box>
    </Stack>
  )
}
